import { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import useStatWidgetVisibility from './useStatWidgetVisibility';
import MonitoringChip from './MonitoringChip';
import ActiveCamerasChip from './ActiveCamerasChip';
import BarrierTriggersChip from './BarrierTriggersChip';
import PaidChip from './PaidChip';
import RecognitionsChip from './RecognitionsChip';
import ParkingChip from './ParkingChip';
import QrCodeChip from './QrCodeChip';

const widgetsList = [
  { 
    key: 'monitoring',
    node: MonitoringChip,
  },
  { 
    key: 'activeCameras',
    node: ActiveCamerasChip,
  },
  { 
    key: 'barrierTriggers',
    node: BarrierTriggersChip,
  },
  { 
    key: 'paid',
    node: PaidChip,
  },
  { 
    key: 'recognitions',
    node: RecognitionsChip,
  },
  { 
    key: 'parking',
    node: ParkingChip,
  },
  { 
    key: 'qrCode',
    node: QrCodeChip,
  },
]


const StatWidgetsAppBar = () => {
  const theme = useTheme();
  const [openItem, setOpenItem] = useState(null);
  const { visibility } = useStatWidgetVisibility();
  const hasVisibleWidgets = Object.values(visibility).some(Boolean);
  if (!hasVisibleWidgets) return null;
  
  const onItemClick = (key) => {
    if (key && openItem === key) {
      setOpenItem(null);
      return;
    }
    setOpenItem(key);
  }

  const onClickAwayHandler = (e) => {
    if (!openItem) return;
    // if (e.target.closest('.MuiButtonBase-root')) return;
    e.preventDefault();
    e.stopPropagation();
    setOpenItem(null);
  }

  return (
    <AppBar
      position="static" 
      elevation={8}
      sx={{
        backgroundColor: theme.palette.background.paper,
        px: { xs: 1, sm: 2, md: 3 },
        height: {
          sm: 32,
          lg: 40,
        },
        border: 'none',
        // borderBottom: '1px solid',
        // borderColor: 'divider',
      }}
    >
      <ClickAwayListener 
        onClickAway={onClickAwayHandler}
      >
        <Stack
          direction="row"
          sx={{
            height: "100%",
            alignSelf: 'baseline'
          }}>
            {
              widgetsList.filter(({ key }) => visibility[key]).map(({ key, node: WidgetNode }) => (
                <WidgetNode 
                  key={key} 
                  onClick={() => onItemClick(key)}
                  open={openItem === key}
                />
              ))
            }
        </Stack>
      </ClickAwayListener>
    </AppBar>
  );
};

export default StatWidgetsAppBar;
